import styled from 'styled-components';
import { getCDNImageUrl } from '@/helpers/cdn';

const logoMinIcon = getCDNImageUrl('/icon-img/logoMin.svg');
const logo = getCDNImageUrl('/icon-img/logo.svg');

export const ScAnimatedLogo = styled.div`
  position: relative;
  top: -4px;
  z-index: -1;
`;

interface ScLogoProps {
  logoMin: boolean;
}

export const ScLogo = styled.div<ScLogoProps>`
  width: ${({ logoMin }) => (logoMin ? '48px' : '140px')};
  height: 40px;
  background: ${({ logoMin }) =>
    `url(${logoMin ? logoMinIcon : logo}) center no-repeat`};
  background-size: contain;
`;
